import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function OTPVerificationModal({ 
  isOpen, 
  onClose, 
  email, 
  onVerify, 
  isLoading = false 
}) {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    if (!otp || otp.length !== 6) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }
    
    onVerify(otp);
  };

  const handleClose = () => {
    setOtp('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-blueGray border-2 border-borderGray rounded-lg p-6 w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-white">Verify Email</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-gray-300 mb-4">
            We've sent a 6-digit verification code to:
          </p>
          <p className="text-primaryBlue font-medium">{email}</p>
        </div>

        {/* OTP Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-white mb-2">
              Enter OTP Code
            </label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="000000"
              className="w-full rounded-md bg-[#384355] text-white border-borderGray hover:border-primaryBlue focus:border-primaryBlue focus:outline-none border-2 p-3 text-center text-2xl font-mono tracking-widest placeholder-gray-400"
              maxLength={6}
              disabled={isLoading}
            />
            {error && (
              <p className="text-red-400 mt-2 text-sm">{error}</p>
            )}
          </div>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 border border-white text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 bg-primaryBlue text-white px-4 py-2 rounded hover:bg-primaryBlue/90 transition-colors disabled:opacity-50"
              disabled={isLoading || otp.length !== 6}
            >
              {isLoading ? 'Verifying...' : 'Verify'}
            </button>
          </div>
        </form>

        {/* Resend Option */}
        <div className="mt-4 text-center">
          <p className="text-gray-400 text-sm">
            Didn't receive the code?{' '}
            <button
              onClick={() => {
                // This will be handled by parent component
                console.log('Resend OTP');
              }}
              className="text-primaryBlue hover:text-blue-400 transition-colors"
            >
              Resend OTP
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
